import { FC } from 'react';
import { translate } from 'localizations';
import TooltipCustom from 'components/common/Tooltip/Tooltip';
import CriteriaTemplate from '../CriteriaTemplate';
import { optionsCreatorSimpleTitle, ValueObj } from 'utils/optionsCreator';
import cn from 'classnames';
import type { ConvertedTemplateOption, CriteriasTopHeaderProps } from '../types';
import { Typography } from '@mui/material';
import { IconQuestion } from 'shared/ui';

export const CriteriasTopHeader: FC<CriteriasTopHeaderProps> = ({
	classes,
	language,
	blockTitle,
	titleTooltip,
	currentTemplate,
	convertedTemplate,
	allTemplates,
	simpleListWithTitles,
	onTemplateSelectValueChange,
	onClearTemplateClick,
	hideParametersBlock = false,
}) => {
	const showTemplates = currentTemplate !== undefined && allTemplates !== undefined && !simpleListWithTitles;
	const headerTitle = blockTitle || translate('fragmentSearch', language);
	const headerTooltip = titleTooltip || translate('tooltipFragments', language);

	return (
		<div className={classes.topHeaderRoot}>
			<div className={cn(classes.searchTitleTop, hideParametersBlock && classes.searchTitleTopFullWidth)}>
				<div className={classes.searchTitleLeft}>
					<Typography className={classes.searchTitleTitle} variant="subtitle1">
						{headerTitle}
					</Typography>
					<TooltipCustom background="dark" title={headerTooltip} placement="right">
						<div className={classes.questionWrapper}>
							<IconQuestion />
							<div className={classes.questionTitle}>{translate('howToSearch', language)}</div>
						</div>
					</TooltipCustom>
					{showTemplates && (
						<CriteriaTemplate
							height="400px"
							name="templatesCalls"
							title={translate('savedSearchTemp', language)}
							handleValueChange={onTemplateSelectValueChange as (value: ValueObj) => void}
							options={convertedTemplate as ConvertedTemplateOption[]}
							currentTemplate={optionsCreatorSimpleTitle(currentTemplate)}
							allTemplates={allTemplates}
							onClearTemplateClick={onClearTemplateClick}
							dataTestTd="templatesCalls"
						/>
					)}
				</div>
			</div>
			{!hideParametersBlock && (
				<div className={classes.searchTitleTopRight}>
					<div className={classes.searchTitleLeft}>
						<Typography className={classes.searchTitleTitle} variant="subtitle1">
							{translate('callsParameters', language)}
						</Typography>
						<TooltipCustom background="dark" title={translate('tooltipParam', language)} placement="bottom">
							<div className={classes.questionWrapper}>
								<IconQuestion />
								<div className={classes.questionTitle}>{translate('whatIsIt', language)}</div>
							</div>
						</TooltipCustom>
					</div>
				</div>
			)}
		</div>
	);
};
